import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faOilWell } from '@fortawesome/free-solid-svg-icons/faOilWell';
import type { IconProps } from '../../types';

export function OilWellIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Oil Well',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faOilWell}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
